import { styled } from '@mui/material'

export const PdfDocWrapper = styled('div')`
  height: 400px;
  overflow: scroll;
`
